import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { BasketType } from '@/enums';
import { computed, nextTick, ref } from 'vue';
import { useValidator } from '@/core/app.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddToBasketWithQuantity',
  props: {
    productId: null,
    allowsCordCutting: { type: Boolean },
    text: null,
    quoteText: null,
    placeholderText: null,
    reference: null,
    disabled: { type: Boolean },
    inputClass: { default: '' }
  },
  emits: ["added"],
  setup(__props: any, { emit }: { emit: ({(e: 'added'): void}), expose: any, slots: any, attrs: any }) {

const props = __props as { productId: string, allowsCordCutting?: boolean, text?: string, quoteText?: string, placeholderText?: string, reference?: string, disabled?: boolean, inputClass: string }




const isQuoteBasketVisible = computed(() => store.getters['app/isQuoteBasketVisible']);
function addToBasket(payload: AddToBasketWebRequest) : void {
    store.dispatch('basket/addToBasket', payload);
}
function addToQuoteBasket(payload: AddToBasketWebRequest) : void {
    store.dispatch('quotebasket/addToQuoteBasket', payload);
}
const isBasketLocked = computed<boolean>(() => store.getters['basket/isBasketLocked']);
const variantBeingAdded = computed<string | null>(() => store.getters['basket/variantBeingAdded']);
const quantityText = ref<string>('1');

const productAddedToCart = ref<boolean>(false);
const quoteProductAddedToCart = ref<boolean>(false);
const showProductCordCuttingModal = ref<boolean>(false);
const showQuoteProductCordCuttingModal = ref<boolean>(false);
const cordLength = ref<string>(null);
const serviceProductId = ref<string>(null);

const addToBasketRequest = computed<AddToBasketWebRequest>(() => (
    {
        id: props.productId,
        quantity: quantity.value,
        reference: props.reference,
        basketType: null,
        cordLength: cordLength.value,
        serviceProductId: serviceProductId.value,
        discountPercent: null
    }));

const addToQuoteBasketRequest = computed<AddToBasketWebRequest>(() => ({
    id: props.productId,
    quantity: quantity.value,
    reference: props.reference,
    basketType: BasketType.Quotation as any,
    cordLength: cordLength.value,
    serviceProductId: serviceProductId.value,
    discountPercent: null
}));

const showSpinner = computed<boolean>(() => {
    if (variantBeingAdded.value === null) { return false; }

    return props.productId === variantBeingAdded.value;
});

const quantity = computed<number>(() => {
    if (!quantityText.value) { return 0; }

    let number: number = parseInt(quantityText.value, 10);

    if (Number.isNaN(number)) { number = 0; }

    return number;
});

const $validator = useValidator();

function showAddToCartInteraction() {
    productAddedToCart.value = true;

    nextTick(() => {
        setTimeout(() => {
            productAddedToCart.value = false;
        }, 2000);
    });
}

function showQuoteAddToCartInteraction() {
    quoteProductAddedToCart.value = true;

    nextTick(() => {
        setTimeout(() => {
            quoteProductAddedToCart.value = false;
        }, 2000);
    });
}

function addProduct() {
    if (quantity.value === 0 || quantity.value > 999) { return; }

    if (props.allowsCordCutting) {
        showProductCordCuttingModal.value = true;
    } else {
        addProductInternal();
    }
}

function addProductWithCordCutting(serviceProduct: string = null, length: string = null) {
    cordLength.value = length || null;
    serviceProductId.value = serviceProduct || null;
    addProductInternal();
}

function addProductInternal() {
    addToBasket(addToBasketRequest.value);

    quantityText.value = '';
    cordLength.value = null;
    serviceProductId.value = null;
    nextTick(() => $validator.reset());
    emit('added');

    showAddToCartInteraction();
}

function addQuoteProduct() {
    if (quantity.value === 0) { return; }

    if (props.allowsCordCutting) {
        showQuoteProductCordCuttingModal.value = true;
    } else {
        addQuoteProductInternal();
    }
}

function addQuoteProductWithCordCutting(serviceProduct: string = null, length: string = null) {
    cordLength.value = length || null;
    serviceProductId.value = serviceProduct || null;
    addQuoteProductInternal();
}

function addQuoteProductInternal() {
    addToQuoteBasket(addToQuoteBasketRequest.value);

    quantityText.value = '';
    cordLength.value = null;
    serviceProductId.value = null;
    nextTick(() => $validator.reset());
    emit('added');

    showQuoteAddToCartInteraction();
}

return { __sfc: true,props, emit, isQuoteBasketVisible, addToBasket, addToQuoteBasket, isBasketLocked, variantBeingAdded, quantityText, productAddedToCart, quoteProductAddedToCart, showProductCordCuttingModal, showQuoteProductCordCuttingModal, cordLength, serviceProductId, addToBasketRequest, addToQuoteBasketRequest, showSpinner, quantity, $validator, showAddToCartInteraction, showQuoteAddToCartInteraction, addProduct, addProductWithCordCutting, addProductInternal, addQuoteProduct, addQuoteProductWithCordCutting, addQuoteProductInternal }
}

})